<template>
  <div class="a-post">
    <h1 v-if="single" class="post-title">{{post.title}}</h1>
    <h1 v-else class="post-title summary-title">
      <router-link :to="`/${firstCategory}/${post.slug}`">{{post.title}}</router-link>
    </h1>

    <img class="featured-image" v-if="featuredImage && single" :src="`${featuredImage}`">

    <div v-if="single" v-html="post.body" class="single-full"></div>
    <p v-else class="single-summary">{{post.summary}}</p>
  </div>
</template>

<script>
import "@/assets/js/prism.js";
import "@/assets/css/prism.css";

export default {
  name: "APost",
  props: ["post", "single"],
  computed: {
    firstCategory: function() {
      return this.post.categories[0].slug;
    },
    featuredImage: function() {
      return this.post.featured_image;
    }
  }
};
</script>

<style scoped>
.a-post {
  margin-bottom: 100px;
}

@media (max-width: 992px) {
  .a-post {
    margin-bottom: 50px;
  }
}

h1 {
  font-size: 220%;
  line-height: 1;
}

h1 a {
  text-decoration: none;
  color: #000;
  transition: color 0.15s linear;
}

h1 a:hover {
  color: #7ea8be;
}

code {
  background: #2d2d2d;
  color: #ccc;
}

figure.image {
  margin-left: 0;
  margin-right: 0;
}
figure.image img,
img {
  max-width: 100%;
}

.featured-image {
  margin-bottom: 30px;
}
</style>
